import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  EntityState,
} from "@reduxjs/toolkit";
import { countriesAPI as API } from "../../apis/countries";
import { RootState } from "../store";

export const loadCountries = createAsyncThunk(
  "countries/load",
  () => API.fetch(),
  {
    condition: (arg, { getState }: any) => {
      const { countries } = getState() as RootState;
      if (countries.status !== "idle") return false;
    },
  }
);

const itemsAdapter = createEntityAdapter<Country>();
interface State extends EntityState<Country> {
  status: "idle" | "loading" | "succeeded" | "failed";
}
const initialState: State = {
  ...itemsAdapter.getInitialState(),
  status: "idle",
};

const slice = createSlice({
  name: "countries",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadCountries.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadCountries.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(loadCountries.fulfilled, (state, action) => {
        state.status = "succeeded";
        itemsAdapter.setAll(state, action.payload.data);
      });
  },
});

export default slice.reducer;
